import { BenchmarkMatchResult, MarketPosition } from 'modules/job_catalog/benchmark/types'

const hasValue = (value?: number | null): value is number => value != null

const getComparableMedian = (match: BenchmarkMatchResult): number | null => {
  if (!match.companySalaryRange) return null

  const { min, max, gross } = match.companySalaryRange

  if (hasValue(gross)) return gross
  if (hasValue(min) && hasValue(max)) return (min + max) / 2
  if (hasValue(min)) return min
  if (hasValue(max)) return max

  return null
}

/**
 * Determines market position based on PRD specification:
 * - BELOW: company median < 90% of market P50
 * - AT_MARKET: company median between 90% and 110% of market P50
 * - ABOVE: company median > 110% of market P50
 * Threshold: +-10%
 */
export const computeMarketPosition = (match: BenchmarkMatchResult): MarketPosition => {
  if (!hasValue(match.tgaP50)) return 'unknown'

  const companyMedian = getComparableMedian(match)
  if (companyMedian == null) return 'unknown'

  const marketMedian = match.tgaP50
  if (marketMedian <= 0) return 'unknown'

  const delta = (companyMedian - marketMedian) / marketMedian
  const threshold = 0.1

  if (delta < -threshold) return 'below'
  if (delta > threshold) return 'above'

  return 'at_market'
}
